import { FC } from 'react'

/**
 * WebSpinner 컴포넌트
 * - Tailwind CSS 기반 로딩 스피너
 * - 3개의 점이 순차적으로 깜빡이는 애니메이션
 */
const WebSpinner: FC = () => {
  return (
    <div className="flex h-screen w-full flex-row items-center justify-center">
      <style>{`
        @keyframes blink {
          0% {
            opacity: 0.25;
          }
          35%, 70% {
            opacity: 1;
          }
          100% {
            opacity: 0.25;
          }
        }
        .dot {
          width: 8px;
          height: 8px;
          background: #0091cf;
          border-radius: 50%;
          margin: 8px;
          opacity: 0;
          animation: blink 1.5s infinite;
        }
      `}</style>
      <div className="dot" style={{ animationDelay: '0ms' }} />
      <div className="dot" style={{ animationDelay: '200ms' }} />
      <div className="dot" style={{ animationDelay: '400ms' }} />
    </div>
  )
}

export default WebSpinner
